import logo from './img/elite-logo.png';
import navBackground from './img/footer2.png';
import footerBackground from './img/footer2.png';
import contactHero from './contact_hero.png';
import contactMap from './img/map-contact.png';
import roomDetailsHero from './img/RoomDetails.png';
import customerHotelImage from './img/gallSlider/20.png';
import aboutBackground from './img/bg.png';
import aboutSlide1 from './img/gallSlider/18.png';
import aboutSlide2 from './img/gallSlider/19.png';
import aboutSlide3 from './img/gallSlider/13.png';
import receptionHero from './img/gallSlider/18.png';
import receptionGrid1 from './img/gallSlider/23.png';
import receptionGrid2 from './img/gallSlider/19.png';
import receptionGrid3 from './img/gallSlider/30.png';
import roomHero from './img/gallSlider/13.png';
import roomGrid1 from './img/gallSlider/1.png';
import roomGrid2 from './img/gallSlider/5.png';
import roomGrid3 from './img/gallSlider/8.png';
import gallerySuperior1 from './img/rooms/1.png';
import gallerySuperior2 from './img/rooms/2.png';
import gallerySuperior3 from './img/rooms/3.png';
import galleryQueen1 from './img/rooms/4.png';
import galleryQueen2 from './img/rooms/5.png';
import galleryQueen3 from './img/rooms/6.png';
import gallerySuite1 from './img/rooms/7.png';
import gallerySuite2 from './img/rooms/8.png';
import gallerySuite3 from './img/rooms/9.png';
import galleryProperty1 from './img/gallSlider/18.png';
import galleryProperty2 from './img/gallSlider/13.png';
import galleryRestaurant1 from './img/restaSlider/3.jpg';
import galleryRoomFeature from './img/gallSlider/13.png';
import galleryWashroom1 from './img/gallSlider/22.png';
import galleryWashroom2 from './img/gallSlider/23.png';
import galleryWashroom3 from './img/gallSlider/30.png';
import restaurantMenu from './img/restaSlider/menu.jpg';
import restaurantSlide1 from './img/restaSlider/1.jpg';
import restaurantSlide2 from './img/restaSlider/3.jpg';
import restaurantSlide3 from './img/restaSlider/1.jpg';
import restaurantBackground from './img/bg.png';
import adminLoginBackground from './img/admingall/loginbg.png';

export const hotelAssets = {
  logo,
  navBackground,
  footerBackground,
  contactHero,
  contactMap,
  roomDetailsHero,
  customerHotelImage,
  aboutBackground,
  aboutSlides: [aboutSlide1, aboutSlide2, aboutSlide3],
  heroSlides: {
    reception: {
      leftImg: receptionHero,
      rightImgs: [receptionGrid1, receptionGrid2, receptionGrid3],
    },
    rooms: {
      leftImg: roomHero,
      rightImgs: [roomGrid1, roomGrid2, roomGrid3],
    },
  },
  gallery: {
    all: [
      gallerySuperior1,
      gallerySuperior2,
      gallerySuperior3,
      galleryQueen1,
      galleryQueen2,
      galleryQueen3,
      gallerySuite1,
      gallerySuite2,
      galleryRestaurant1,
      galleryRoomFeature,
    ],
    property: [galleryProperty1, galleryProperty2],
    rooms: {
      suit: [gallerySuite1, gallerySuite2, gallerySuite3],
      queen: [galleryQueen2, galleryQueen1, galleryQueen3],
      superior: [gallerySuperior1, gallerySuperior2, gallerySuperior3],
    },
    washroom: [galleryWashroom1, galleryWashroom2, galleryWashroom3],
    covers: {
      all: gallerySuperior1,
      property: galleryProperty1,
      washroom: galleryWashroom1,
      suit: gallerySuite1,
      queen: galleryQueen1,
      superior: gallerySuperior1,
    },
  },
  restaurant: {
    menu: restaurantMenu,
    slides: [restaurantSlide1, restaurantSlide2, restaurantSlide3],
    background: restaurantBackground,
  },
  login: {
    background: adminLoginBackground,
  },
};
